import { defineMessages } from 'react-intl';

export const messages: {
	workItemLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	taskLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	epicLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bugLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	storyLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	milestoneLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sectionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	approvalLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	problemLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	incidentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	questionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issueLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ticketLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	requestedItemLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	catalogItemLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	for: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	isAssigned: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	created: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	workItemLabel: {
		id: 'search-graph-work-item.label',
		defaultMessage: 'Work item',
		description:
			'Badge label shown on a work item search result to indicate the generic work item result type.',
	},
	taskLabel: {
		id: 'search-graph-work-item.task.label',
		defaultMessage: 'Task',
		description:
			'Badge label shown on a work item search result to identify the issue type as a task.',
	},
	epicLabel: {
		id: 'search-graph-work-item.epic.label',
		defaultMessage: 'Epic',
		description:
			'Badge label shown on a work item search result to identify the issue type as an epic.',
	},
	bugLabel: {
		id: 'search-graph-work-item.bug.label',
		defaultMessage: 'Bug',
		description:
			'Badge label shown on a work item search result to identify the issue type as a bug.',
	},
	storyLabel: {
		id: 'search-graph-work-item.story.label',
		defaultMessage: 'Story',
		description:
			'Badge label shown on a work item search result to identify the issue type as a story.',
	},
	milestoneLabel: {
		id: 'search-graph-work-item.milestone.label',
		defaultMessage: 'Milestone',
		description:
			'Badge label shown on a work item search result to identify the issue type as a milestone.',
	},
	sectionLabel: {
		id: 'search-graph-work-item.section',
		defaultMessage: 'Section',
		description:
			'Badge label shown on a work item search result to identify the issue type as a section.',
	},
	approvalLabel: {
		id: 'search-graph-work-item.approval',
		defaultMessage: 'Approval',
		description:
			'Badge label shown on a work item search result to identify the issue type as an approval.',
	},
	problemLabel: {
		id: 'search-graph-work-item.problem',
		defaultMessage: 'Problem',
		description:
			'Badge label shown on a work item search result to identify the issue type as a problem.',
	},
	incidentLabel: {
		id: 'search-graph-work-item.incident',
		defaultMessage: 'Incident',
		description:
			'Badge label shown on a work item search result to identify the issue type as an incident.',
	},
	questionLabel: {
		id: 'search-graph-work-item.question',
		defaultMessage: 'Question',
		description:
			'Badge label shown on a work item search result to identify the issue type as a question.',
	},
	issueLabel: {
		id: 'search-graph-work-item.issue',
		defaultMessage: 'Issue',
		description:
			'Badge label shown on a work item search result to identify the issue type as an issue.',
	},
	ticketLabel: {
		id: 'search-graph-work-item.ticket',
		defaultMessage: 'Ticket',
		description:
			'Badge label shown on a work item search result to identify the issue type as a ticket.',
	},
	requestedItemLabel: {
		id: 'search-graph-work-item.requested_item',
		defaultMessage: 'Requested item',
		description:
			'Badge label shown on a work item search result to identify the issue type as a requested item.',
	},
	catalogItemLabel: {
		id: 'search-graph-work-item.catalog_item',
		defaultMessage: 'Catalog item',
		description:
			'Badge label shown on a work item search result to identify the issue type as a catalog item.',
	},
	for: {
		id: 'work-item-status.for',
		defaultMessage: '{statusLozenge} for {dateLozenge}',
		description: 'The conjunction between a status and date e.g. "On track for August"',
	},
	isAssigned: {
		id: 'work-item-assignee.assigned',
		defaultMessage:
			'{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
		description:
			'Text shown in a work item search result indicating the assignee. When {isAssigned} is "internal", {firstName} is substituted with the assignee\'s first name. Otherwise, a generic "External person" label is shown.',
	},
	created: {
		id: 'work-item-creator.created',
		defaultMessage:
			'{created, select, internal {{firstName} created} other {External person created}}',
		description:
			'Text shown in a work item search result indicating the creator. When {created} is "internal", {firstName} is substituted with the creator\'s first name. Otherwise, a generic "External person" label is shown.',
	},
});
